module.exports = __webpack_public_path__ + "img/tt-2.5a03b258.png";